module.exports = __webpack_public_path__ + "img/p2-p2-yanzi1.f24fa18b.png";